import type { LeadId } from "@gs/core/domain/Lead/Lead";
import { createDomainStore } from "../_utils/createDomainStore";

export type LeadMetaDataSource = "bd" | "elastic"

export type LeadMetaData = {
  dataLoadedAt: number // timestamp: Date.now()
  source: LeadMetaDataSource
}

export const [leadMetaStore, useLeadMetaStore] = createDomainStore<LeadMetaData, LeadId>("leadMeta");
